<template>
    <a-config-provider
      :theme="{
        token:themeToken,
        algorithm: algorithm,
      }"
    >
    <div class="v-between-center">
      <div class="flex1">
          <RouterView />
      </div>
      <div  class="webFoot">Ⓒ Copyrights {{year }} - Powered by Big Dipper Studio | Version:{{ version }}</div>

    </div>
  </a-config-provider>
</template>

<script> 
import { RouterView, useRouter,useRoute } from 'vue-router'
import DarkColor from "@/config/dark-color.js";
import LightColor from "@/config/light-color.js";
import {version} from "@/config/config"
  import { theme } from 'ant-design-vue';
export default {
  name: 'App',
  components: {
   RouterView
  },
  data:()=>{
    return {
      themeToken:null,
      algorithm:null
    }
  },
  mounted() {
    const initUserTheme =localStorage.getItem("user-theme")|this.getMediaPreference();
    if(initUserTheme=="dark-theme"){
        this.algorithm=theme.darkAlgorithm;
        this.themeToken=DarkColor;
        
    }else{
        this.algorithm=theme.compactAlgorithm;
        this.themeToken=LightColor;
    }
    console.log(this.themeToken)
  },
  computed: {
    theme () {
      return this.$store.state.theme;
      // Or return basket.getters.fruitsCount
      // (depends on your design decisions).
    }
  },
  methods:{
    getMediaPreference(){
      const hasDarkPreference = window.matchMedia(
        "(prefers-color-scheme: dark)"
      ).matches;
      if (hasDarkPreference) {
        return "dark-theme";
      } else {
        return "light-theme";
      }
    },
  },
  watch: {
    theme (newCount, oldCount) {
      if(newCount=="dark-theme"){
        this.algorithm=theme.darkAlgorithm;
        this.themeToken=DarkColor;
    }else{
        this.themeToken=LightColor;
        this.algorithm=theme.defaultAlgorithm;
      }
    }
  },
  setup(){
    var router=useRouter();
    var route=useRoute();
    setTimeout(()=>{
    console.log(route,route.name)
    if(localStorage.getItem("token")==null&&
      route.name!="login"&&
      route.name!="forgotpw"
    ){
        router.replace("/login")
        return {RouterView,version}
    }
    },1000)
    console.log("version",version)
    const year=(new Date()).getFullYear()
    return {RouterView,version,year}
  }
}
</script>

<style scoped>
.webFoot{
  background-color: var(  --web-footer);
  color:var( --color-background);
  font-size: 1rem;
  font-weight: 700;
  line-height:1.21rem;
  text-align: center;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  flex: 0 0 3rem;
}
</style>